import { InnoCheckbox } from '@innomotics/innomotics-build-react-lib';
import React, { KeyboardEvent } from 'react';

interface CheckboxProps {
    checked: boolean;
    label: string;
    onChange: (value: boolean) => void;
    dark?: boolean;
    disabled?: boolean;
}

const Checkbox = ({ checked, dark, disabled, label, onChange }: CheckboxProps) => {
    
    const handleChange = () => {
        if (!disabled) {
            onChange(!checked);
        }
    };

    const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        if (event.key === ' ') {
            event.preventDefault();
            handleChange();
        }
    };

    return (
        /*
        <div className={`checkbox-container ${disabled ? 'disabled' : ''} ${dark ? 'dark' : ''}`} tabIndex={disabled ? undefined : 0} onClick={handleChange} onKeyDown={handleKeyDown}>
            <div className={`checkbox ${checked ? 'checked' : ''}`}>
                <div className='checkmark' />
            </div>
            <div className='checkbox-label'>
                {label}
            </div>
        </div>*/

        <InnoCheckbox label={label} onValueChange={handleChange} checked={checked} disabled={disabled}></InnoCheckbox>
    );
};

export default Checkbox;
